var arabam;
(function (arabam) {
    var SearchService = /** @class */ (function () {
        function SearchService($q, $window, HttpHelperService) {
            this.$q = $q;
            this.$window = $window;
            this.HttpHelperService = HttpHelperService;
            this.viewDictionary = ["List", "Detailed", "Box"];
            this.rangeFacetDictionary = ["price", "km", "year"];
            this.isMobile = window.configuration.IsMobile;
        }
        SearchService.prototype.searchAndGetHtml = function (url) {
            var d = this.$q.defer();
            this.HttpHelperService.httpGet(url, function (res) {
                d.resolve(res);
            }, function () {
                d.reject();
            }, { isNotLoading: this.isMobile ? true : false });
            return d.promise;
        };
        SearchService.prototype.prepareSearchUrl = function (selectedFilters) {
            var _this = this;
            var _a = this.createQueryBaseBootstrap(this.$window.location.pathname), base = _a.base, isFirmPage = _a.isFirmPage;
            var selectedCategories = selectedFilters.filter(function (filter) { return filter.Value && filter.PropertyName === "category"; });
            var categoryCount = selectedCategories ? selectedCategories.length : 0;
            var _b = this.processCategoryFilter(selectedCategories, isFirmPage), path = _b.path, querystring = _b.querystring;
            /**
             * minPrice, maxPrice gibi degerler girilmisse o facetlerin
             * checkbox degerlerini temizle
             */
            selectedFilters = this.clearRangeFacets(selectedFilters);
            var _c = this.checkMinAndMax(selectedFilters), minPriceExists = _c.minPriceExists, maxPriceExists = _c.maxPriceExists;
            // kategori olanlari zaten handle etmistik
            selectedFilters
                .filter(function (filter) { return filter.PropertyName != "category"; })
                .map(function (filter) {
                // ASD-4690 SEO - redirectAdvertId hakkında
                if (filter.PropertyName === "redirectAdvertId" ||
                    (filter.IsDynamic && categoryCount == 0) ||
                    (filter.PropertyName === "currency" && !(minPriceExists || maxPriceExists))) {
                    return filter;
                }
                if (filter.PropertyName == "view") {
                    querystring += "&" + filter.PropertyName + "=" + _this.viewDictionary[+filter.Value];
                    return filter;
                }
                if (filter.PropertyName == "tag" || filter.PropertyName == "swap" || filter.PropertyName == "koltuksayisi") {
                    querystring += "&" + filter.PropertyName + "=" + encodeURIComponent(filter.Value);
                    return filter;
                }
                querystring += "&" + filter.PropertyName + "=" + filter.Value;
                return filter;
            });
            querystring += this.processSortFilter(querystring);
            return base + path + "?" + querystring;
        };
        /** ayni tip facetten kac secim yapilmis, kac kategori, kac sehir kac town */
        SearchService.prototype.calculateHowManyOfTheSameFacet = function (selectedFilters, propertyName) {
            return selectedFilters.filter(function (filter) { return filter.PropertyName === propertyName; }).length;
        };
        /**
         *  range facet logici
         *  min, max degeri varsa ve modified==true ise checkboxları yoket
         *  checkbox deger varsa ve modified==true ise min max degerleri yoket
         */
        SearchService.prototype.clearRangeFacets = function (selectedFilters) {
            var self = this;
            this.rangeFacetDictionary.map(function (rangeFacetName) {
                selectedFilters = self.clearCheckboxValuesOfSingleRangeFacet(selectedFilters, rangeFacetName);
            });
            return selectedFilters;
        };
        /**
         * filter.Modified kullanicinin ui uzerinden yaptigi degisiklerde set edilir
         * yani Modified == true ise kullanici o filtreyi yeni set etmistir
         */
        SearchService.prototype.clearCheckboxValuesOfSingleRangeFacet = function (selectedFilters, facetToCheck) {
            var minOrMaxValues = selectedFilters.filter(function (filter) {
                return (filter.PropertyName.toLowerCase() == "min" + facetToCheck ||
                    filter.PropertyName.toLowerCase() == "max" + facetToCheck) &&
                    filter.Modified;
            });
            // min ya da max deger girilmis, checkboxlari yoket
            if (minOrMaxValues && minOrMaxValues.length > 0) {
                selectedFilters = selectedFilters.filter(function (filter) { return filter.PropertyName != facetToCheck; });
            }
            // kullanici checkbox secmis mi?
            var checkboxes = selectedFilters.filter(function (filter) { return filter.PropertyName.toLowerCase() == facetToCheck && filter.Modified; });
            // checkbox secilmis, min max degerlerini yoket
            if (checkboxes && checkboxes.length > 0) {
                selectedFilters = selectedFilters.filter(function (filter) {
                    return !(filter.PropertyName.toLowerCase() == "min" + facetToCheck ||
                        filter.PropertyName.toLowerCase() == "max" + facetToCheck);
                });
            }
            return selectedFilters;
        };
        /**
         * ASD-4834 ile geliştirilen sorted filter ile sabit url oluşturulması
         * @author Emre DOĞAN <emre.dogan@arabam.com> - 17 Mayıs 2018
         * @link https://arabam.atlassian.net/browse/ASD-4834
         * @link PR - https://bitbucket.org/arabamcomdevelopmentteam/arabam.com-old/pull-requests/
         */
        SearchService.prototype.sortFilters = function (selectedFilters) {
            return selectedFilters.sort(function (previous, next) {
                var previousName = previous.PropertyName.toLowerCase();
                var nextName = next.PropertyName.toLowerCase();
                return previousName > nextName ? 1 : previousName < nextName ? -1 : 0;
            });
        };
        SearchService.prototype.createPrettyUrl = function (selectedFilters) {
            return selectedFilters.map(function (filter) { return filter.Text; }).join("-");
        };
        SearchService.prototype.createQueryBaseBootstrap = function (path) {
            return path.indexOf("ikinci-el/") > -1
                ? { base: "/ikinci-el", isFirmPage: false }
                : path.indexOf("sifir-km/") > -1
                    ? { base: "/sifir-km", isFirmPage: false }
                    : { base: path, isFirmPage: true };
        };
        SearchService.prototype.processCategoryFilter = function (categories, isFirmPage) {
            if (isFirmPage === void 0) { isFirmPage = false; }
            if (categories.length === 0) {
                return {
                    path: "",
                    querystring: ""
                };
            }
            if (categories.length === 1) {
                if (isFirmPage) {
                    return {
                        path: "",
                        querystring: "&category=" + (categories[0].Id || categories[0].Value)
                    };
                }
                //favori aramadan category=14 seklinde geliyor.Onu burada usulca kaldırıyoruz.
                return categories[0].Id === categories[0].Value
                    ? {
                        path: "",
                        querystring: ""
                    }
                    : {
                        path: "/" + categories[0].Value,
                        querystring: ""
                    };
            }
            return {
                path: "",
                querystring: "&" + categories.map(function (category) { return "category=" + category.Id; }).join("&")
            };
        };
        SearchService.prototype.checkMinAndMax = function (filters) {
            return {
                minPriceExists: filters.filter(function (filter) { return filter.PropertyName === "minPrice"; }).length > 0,
                maxPriceExists: filters.filter(function (filter) { return filter.PropertyName === "maxPrice"; }).length > 0
            };
        };
        SearchService.prototype.processSortFilter = function (querystring) {
            var params = window.location.search
                .replace("?", "")
                .split("&")
                .filter(function (filter) { return filter.indexOf("sort") > -1; })[0];
            if (params && querystring.indexOf("sort=") == -1) {
                return "&" + params;
            }
            return "";
        };
        SearchService.$inject = ["$q", "$window", "HttpHelperService"];
        return SearchService;
    }());
    arabam.SearchService = SearchService;
    angular.module("arabam").service("SearchService", SearchService);
})(arabam || (arabam = {}));
